export const desktopSearchbarPadding = 10
export const searchbarHeight = 68
export const mobileSearchbarHeight = 68
